import { render, staticRenderFns } from "./seltos-swiper.vue?vue&type=template&id=58c26e1c&scoped=true&"
import script from "./seltos-swiper.vue?vue&type=script&lang=js&"
export * from "./seltos-swiper.vue?vue&type=script&lang=js&"
import style0 from "./seltos-swiper.vue?vue&type=style&index=0&id=58c26e1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c26e1c",
  null
  
)

export default component.exports